var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-page-base", { attrs: { loading: _vm.loading } }, [
    _vm.appDetails
      ? _c("div", { staticClass: "columns margin-logo" }, [
          _c("div", { staticClass: "column is-10" }, [
            _c(
              "h1",
              { staticClass: "title page-base__title has-text-primary" },
              [
                _vm._v(
                  "\n        Integração com " +
                    _vm._s(_vm.appDetails.app_name) +
                    "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column is-2" }, [
            _vm.appDetails.image_url
              ? _c("img", {
                  staticClass: "img-client",
                  attrs: { src: _vm.appDetails.image_url }
                })
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.initialStep
      ? _c(
          "div",
          [
            _c("sc-form", {
              scopedSlots: _vm._u([
                {
                  key: "fields",
                  fn: function(ref) {
                    var fields = ref.fields
                    return [
                      _c("div", { staticClass: "initial_step" }, [
                        _c(
                          "div",
                          { staticClass: "initial_step__content" },
                          [
                            _c(
                              "h1",
                              [
                                _c("sc-icon", {
                                  attrs: { icon: "clipboard-check" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h2", [
                              _vm._v("Você precisa ter as informações abaixo:")
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Entre em contato com a transportadora e tenha em mãos as seguintes informações:"
                              )
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c(
                                "li",
                                [
                                  _c("sc-icon", {
                                    attrs: { icon: "address-card" }
                                  }),
                                  _vm._v(" Credenciais com a transportadora")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                [
                                  _c("sc-icon", {
                                    attrs: { icon: "address-book" }
                                  }),
                                  _vm._v(" Contato da transportadora")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                [
                                  _c("sc-icon", { attrs: { icon: "box" } }),
                                  _vm._v(" Configurações de envio")
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("sc-button", {
                              attrs: {
                                text: "Concordar e continuar",
                                theme: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.initialStep = false
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      : _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-12" },
            [
              _vm.steps
                ? _c(
                    "sc-steps",
                    {
                      staticClass: "self_service_steps",
                      attrs: { size: "is-medium", "has-navigation": false },
                      model: {
                        value: _vm.activeStep,
                        callback: function($$v) {
                          _vm.activeStep = $$v
                        },
                        expression: "activeStep"
                      }
                    },
                    [
                      _vm._l(_vm.steps, function(step, index) {
                        return _c(
                          "sc-step-item",
                          {
                            key: index,
                            attrs: {
                              label: step.title,
                              step: index + 1,
                              clickable: false
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("sc-form", {
                                  attrs: { autocomplete: "off" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "fields",
                                      fn: function(ref) {
                                        var fields = ref.fields
                                        return [
                                          _c(step.component, {
                                            ref: "stepComponentsRef",
                                            refInFor: true,
                                            tag: "component",
                                            attrs: {
                                              fieldGroupName:
                                                step.fieldGroupName,
                                              fieldGroup: step.fieldGroup
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "actions",
                                      fn: function(ref) {
                                        var isValid = ref.isValid
                                        return [
                                          _c(
                                            "div",
                                            [
                                              step.canBack && _vm.activeStep > 0
                                                ? _c("sc-button", {
                                                    attrs: {
                                                      text: "Voltar",
                                                      theme: "default",
                                                      type: "button"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.backStep()
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("sc-button", {
                                                class: step.name,
                                                attrs: {
                                                  text: "Próximo",
                                                  theme: "primary",
                                                  type: "button"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.navigateNext()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "sc-step-item",
                        {
                          attrs: {
                            step: _vm.steps.length + 1,
                            label: "Concluído"
                          }
                        },
                        [_c("sc-finished")],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1e21896", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1e21896","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/IntegrationsAppSelfService.vue
// module id = null
// module chunks = 